import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';

/**
 * Custom hook that automatically tracks page views on route changes
 * Call this in your root App component
 */
export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    // Get the page title from document
    const pageTitle = document.title || 'INTERPACK A.Ş';
    
    // Track the page view
    trackPageView(location.pathname, pageTitle);
  }, [location.pathname]); // Only re-run when pathname changes
}
